import {
  AnswerHtml,
  PdfHtml,
  QuestionHtml,
} from '@/resource/question/question.model';
import { QuestionLanguage } from '@/resource/subject/subject.model';

export const getMainLanguage = (languages: QuestionLanguage[]) => {
  return `main-${languages[0] ? languages[0] : ''}`;
};

// NOTE: FYI PdfHtml has both question and answer value (might cause issue later)
export const getHtmlByLanguages = (
  htmls: (QuestionHtml | AnswerHtml | PdfHtml)[],
  selectedLanguage: QuestionLanguage[],
) => {
  const languages = JSON.parse(JSON.stringify(selectedLanguage));

  let selectedQuestionHtml:
    | string
    | undefined = `<p>Question not exist for language(s) ${languages.toString()}</p>`;

  if (htmls.length === 1) {
    selectedQuestionHtml =
      (htmls[0] as QuestionHtml).question || (htmls[0] as AnswerHtml).answer;
  } else if (languages.length === 0) {
    const foundHtmls = htmls.find(questionHtml => {
      return questionHtml.languages.length > 1;
    });

    selectedQuestionHtml =
      (foundHtmls as QuestionHtml).question ||
      (foundHtmls as AnswerHtml).answer;
  } else {
    const selectedLanguageString = languages
      .sort()
      .toString()
      .trim();

    const foundHtmls = htmls.find(questionHtml => {
      const htmlLanguages = JSON.parse(JSON.stringify(questionHtml.languages));
      return (
        htmlLanguages
          .sort()
          .toString()
          .trim() === selectedLanguageString
      );
    });

    selectedQuestionHtml =
      (foundHtmls as QuestionHtml).question ||
      (foundHtmls as AnswerHtml).answer;
  }

  return selectedQuestionHtml;
};
